import { AppInsightsDeprecated } from '@microsoft/applicationinsights-web/dist-esm/ApplicationInsightsDeprecated';
import router from '../router/index'

export const SessionState = {
  namespaced: true,
  state: {
    packageid: "",
    currentStage : null,
    package : {},
    activeBabylonPanels : [
        {
            id : "test",
            engine : {},
            scene : {},
            canvas : {},
        }
    ],
    showMainLoadScreen : true,
    showFadeout : false,
    desiredWaypoint : null,
    activeWaypointid : "",
    isProductFocused : false,
    focusedProductData : null,
    showShoppingCart : false,
    currentLanguage : "en",
    navigationBar : false,
    forceLandRotation : false,
    activeTour : null,
    activeTourStep : null,
    activeTourIndex : -1,
    homeScreenVisibility : true,
    audio : null,
    isPlayingAudio : false,
    isInvalidLink : false,
    videoGroups : [],
    forceShowTouchpoint : false,
    forceShowAsset : null,
    forceShowTab : null,
    customSessionData : []
  },

  mutations: {

    AddCustomSessionData(state, dataPayload)
    {
      let match = state.customSessionData.find(item => item.key == dataPayload.key);

      if(match == null)
      {
        state.customSessionData.push(dataPayload);
      }
      else
      {
        match.data = dataPayload.data;
      }
    },
    ClearCustomSessionDataOfKey(state, key)
    {
      let matchingIndex = state.customSessionData.indexOf(item => item.key == key);

      if(matchingIndex != 1)
      {
        state.customSessionData.splice(matchingIndex,1);
      }
    },
    SetForceShowTouchpoint(state, isForced)
    {
      state.forceShowTouchpoint = isForced;
    },
    SetForceShowAsset(state, assetDetailid)
    {
      state.forceShowAsset = assetDetailid;
    },
    SetForceShowTab(state, tab)
    {
      state.forceShowTab = tab;
    },
    SetVideoGroups(state, videoGroupsArray)
    {
      state.videoGroups = videoGroupsArray;
    },
    SetVideoGroupsToPlay(state,waypointid)
    {
      state.videoGroups.forEach(vidGroup => {

        if(vidGroup.waypoints.includes(waypointid))
        {
          vidGroup.meshes.forEach(mesh => {
            if(mesh.material != null && mesh.material.emissiveTexture != null)
            {
              if(mesh.material.emissiveTexture.video.loop)
              {
                mesh.material.emissiveTexture.video.play();
              }
              else if(!mesh.material.emissiveTexture.video.loop && !mesh.material.emissiveTexture.video.ended)
              {
                mesh.material.emissiveTexture.video.play();
              }
            }
          })
        }
        else
        {
          vidGroup.meshes.forEach(mesh => {
            if(mesh.material != null && mesh.material.emissiveTexture != null)
            {
              mesh.material.emissiveTexture.video.pause();
              mesh.material.emissiveTexture.video.currentTime = 0;
            }
              
          })
        }
      });
    },
    SetLinkAsInvalid(state)
    {
      state.isInvalidLink = true;
    },
    PlayAudio(state)
    {
      if(state.audio == null)
      {
        state.audio = new Audio('https://xpcwa.blob.core.windows.net/assets/BackgroundAmbience.mp3');
        state.audio.loop = true;
        state.audio.play();
        state.isPlayingAudio = true;
        state.audio.volume = 0.6;
      }
      else
      {
        if(!state.isPlayingAudio)
        {
          state.audio.play();
          state.isPlayingAudio = true;
        }
      }
    },
    PauseAudio(state)
    {
      if(state.audio != null)
      {
        if(!state.audio.paused)
        {
          state.audio.pause();
          state.isPlayingAudio = false;
        }
      }
      
    },
    LowerAudioVolume(state)
    {
      if(state.audio != null)
        state.audio.volume = 0.2;
    },
    RaiseAudioVolume(state)
    {
      if(state.audio != null)
        state.audio.volume = 0.6;
    },
    SetDesiredWaypoint(state, waypoint)
    {
      state.desiredWaypoint = waypoint;
    },
    SetHomeScreenVisibility(state, isVisible)
    {
      state.homeScreenVisibility = isVisible;
    },
    CloseTour(state, tour)
    {
      state.activeTour = null;
      state.activeTourStep = null;
      state.activeTourIndex = -1;
    },
    SetActiveTour(state, tour)
    {
      state.activeTour = tour;
      state.activeTourIndex = -1;
    },
    SetTouchpointToIndex(state, index)
    {
      state.activeTourIndex = index;
      state.activeTourStep = state.activeTour.tourPoints[index];
    },
    GoNextTourPoint(state)
    {
      let foundValidStep = false;
      let validStep = null;

      for (let i = state.activeTourIndex + 1; i < state.activeTour.tourPoints.length; i++) {
        const element = state.activeTour.tourPoints[i];
        if(element.touchpointid != "" || element.waypointid != "")
        {
          foundValidStep = true;
          validStep = element;
          state.activeTourIndex = i;

          if(foundValidStep)
            break;
        }
      }

      if(foundValidStep)
      {
        state.activeTourStep = validStep;
      }
      else
      {
        //End tour
      }
    },
    GoPrevTourPoint(state)
    {
      let foundValidStep = false;
      let validStep = null;

      for (let i = state.activeTourIndex - 1; i >= 0; i--) {
        const element = state.activeTour.tourPoints[i];
        if(element.touchpointid != "" || element.waypointid != "")
        {
          foundValidStep = true;
          validStep = element;
          state.activeTourIndex = i;

          if(foundValidStep)
            break;
        }
      }

      if(foundValidStep)
      {
        state.activeTourStep = validStep;
      }
    },
    SetForceLandRotation(state, isForced)
    {
      state.forceLandRotation = isForced;
    },
    SetNavigationBar(state, isActive)
    {
      state.navigationBar = isActive;
    },
    SetCurrentLanguage(state, newLocale)
    {
      state.currentLanguage = newLocale;
    },
    SetFocusedProductData(state, focusedProduct)
    {
      state.focusedProductData = focusedProduct;
    },
    SetShoppingCartVisibility(state, showShoppingCart)
    {
      state.showShoppingCart = showShoppingCart;
    },
    SetProductFocus(state, isFocused)
    {
      state.isProductFocused = isFocused;
    },
    SetActiveWaypointid(state, waypointid)
    {
      state.activeWaypointid = waypointid;
    },
    SetDesiredWaypoint(state, waypointid)
    {
      state.desiredWaypoint = waypointid;
    },
    SetFadeoutState(state, isShowing)
    {
      state.showFadeout = isShowing;
    },
    SetMainLoadScreenState(state, isShowing)
    {
      state.showMainLoadScreen = isShowing;
    },
    SetStageData(state, stagePayload)
    {
      state.currentStage = stagePayload;
      state.currentStageData = stagePayload.typeData;
    },
    AddNewBabylonInstance(state, newInstancePayload)
    {
        state.activeBabylonPanels.push({
            id: newInstancePayload.id,
            engine : newInstancePayload.engine,
            scene : newInstancePayload.scene,
            canvas : newInstancePayload.canvas
        });
    },
    RemoveBabylonInstance(state, id)
    {

      for (let i = 0; i < state.activeBabylonPanels.length; i++) {
        
        if(state.activeBabylonPanels[i].id == id)
        {
          state.activeBabylonPanels.splice(i);
          break;
        }
      }
    },
    SetPackageData(state, packagePayload)
    {
        state.package = packagePayload.data;
        state.packageid = packagePayload.id;
    }
  },
  actions: {

    BeginTour({dispatch,state,commit}, tour)
    {
      commit("SetActiveTour",tour);
      commit("GoNextTourPoint",tour);
    },
    FindNextStage({dispatch,state})
    {
      if(state.currentStage == null)
      {
        dispatch('BeginStage',state.package.stages[0]);
      }
    },
    BeginStage({state,commit},stage )
    {
      if(state.currentStage != null)
      {
        if(state.currentStage.id != stage.id)
        {
          router.push("/" + state.packageid + "/env/" + stage.id);
        }
      }
      else
      {
        router.push("/" + state.packageid + "/env/" + stage.id);
      }
      
    }
  },
  getters: {

    GetBabPnl: (state) => (id) => {
        return state.activeBabylonPanels.find(pnl => pnl.id === id);
    },
    GetInsightTemplateForid: (state) => (templateid) => {

      var validTemplates = state.package.insightTemplates.filter(template => template.id == templateid);

      if(validTemplates.length > 0)
      {
        return validTemplates[0];
      }
      else
      {
        return null;
      }
    },
    GetInsightStyleForid: (state) => (styleid) => {

      var validStyles = state.package.insightStyles.filter(style => style.identifier == styleid);

      if(validStyles.length > 0)
      {
        return validStyles[0];
      }
      else
      {
        return null;
      }

    },
    GetAssetForid: (state) => (assetListingid) => {

      console.log("Getting asset for ID: " + assetListingid);
    
      var validAssets = state.package.assets.filter(asset => asset.assetListingid == assetListingid || asset.assetDetailid == assetListingid);

      if(validAssets.length > 0)
      {
        return validAssets[0];
      }
      else
      {
        return null;
      }
    },
    GetAssetsForids: (state) => (assetListingids) => {

      console.log("Getting assets for IDs:",assetListingids);
    
      var validAssets = [];

      assetListingids.forEach(listingid => {

        let foundAsset = state.package.assets.find(asset => listingid == asset.assetListingid || asset.assetDetailid == listingid);

        if(foundAsset != null)
        {
          validAssets.push(foundAsset);
        }
        
      });

      //var validAssets = state.package.assets.filter(asset => assetListingids.some(inner => inner ==  asset.assetListingid || asset.assetDetailid == inner));
      return validAssets;
    },
    CurrentStageData: (state) => {
      if(state.currentStage == null)
        return null
      else
        return state.currentStage.typeData;
    },
    GetIcons : (state) => {
      return state.package.icons;
    }
  }
}